"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const getItemByKeyValue = (collection, key, value) => {
    if ((0, _1.isNil)(collection)) {
        return null;
    }
    // @ts-ignore
    return collection.find((object) => object[key] === value);
};
exports.default = getItemByKeyValue;
